<template>
  <div>
    <tile-grid>
      <scene-tile
        v-for="sceneItem in getScenes"
        :key="sceneItem.id"
        :scene="sceneItem"
        :edit-enabled="scene.isEditModeEnabled"
      />
    </tile-grid>
    <scene-modal-form ref="addSceneModal" :title="$t('add-scene')" @ok="addSceneOk" />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import eventBus from '@/components/utils/slideout-panel/eventBus';
import SceneTile from '@/components/scenes/SceneTile.vue';
import SceneModalForm from '@/components/scenes/scene/SceneModalForm.vue';
import BreadcrumbsManager from '@/mixins/BreadcrumbsManager';
import TileGrid from '@/components/utils/TileGrid';

export default {
  name: 'Scenes',
  mixins: [
    BreadcrumbsManager,
  ],
  data() {
    return {
      breadcrumbs: [
        {
          text: this.$t('scenes'),
        },
      ],
    };
  },
  computed: {
    ...mapState('app', [
      'scene',
    ]),
    ...mapGetters([
      'getScenes',
    ]),
  },
  methods: {
    ...mapActions([
      'addScene',
    ]),
    ...mapActions('app', [
      'setState',
    ]),
    addSceneClicked() {
      this.$refs.addSceneModal.show();
    },
    addSceneOk({ name, icon }) {
      this.addScene({ name, icon });
      this.$refs.addSceneModal.hide();
    },
  },
  created() {
    eventBus.$on('addSceneClicked', this.addSceneClicked);
  },
  destroyed() {
    this.setState({ section: 'scene', setting: { isEditModeEnabled: false } });
  },
  components: {
    TileGrid,
    SceneTile,
    SceneModalForm,
  },
};
</script>

<style scoped lang="scss">
</style>
